import axios from 'axios';
import { FigmaFileStructure } from '../types/figma';

const BASE_URL = process.env.REACT_APP_BACKEND_URL || '/api';

export const figmaApi = {
  getFile: async (fileKey: string): Promise<FigmaFileStructure> => {
    const { data } = await axios.get(`${BASE_URL}/figma/proxy/files/${fileKey}`);
    return data;
  },

  getFileNodes: async (fileKey: string, nodeIds: string): Promise<any> => {
    const { data } = await axios.get(`${BASE_URL}/figma/proxy/files/${fileKey}/nodes`, {
      params: { ids: nodeIds },
    });
    return data;
  },

  /**
   * Fetches image URLs from Figma via our proxy.
   * Returns a map of nodeId -> S3 URL that can be used directly in <img src>.
   * This matches the POC approach: get URLs from Figma, use them directly.
   */
  getImageUrls: async (
    fileKey: string,
    nodeIds: string,
    format = 'png',
    scale = 1
  ): Promise<Record<string, string>> => {
    const { data } = await axios.get(`${BASE_URL}/figma/proxy/image-urls/${fileKey}`, {
      params: { ids: nodeIds, format, scale },
    });
    return data.images || {};
  },
};
